import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "users",
    object: "user",
    header: [
      { text: "Nombre", value: "name", class: "py-3" },
      { text: "Apellido", value: "last_name", class: "py-3" },
      { text: "Email", value: "email", class: "py-3" },
      { text: "Fecha de creación", value: "created_at", class: "py-3" },
      { text: "Teléfono", value: "phone_number", class: "py-3", sortable: false },
      { text: "Estadias Realizadas", value: "rent_orders", class: "py-3" },
      { text: "Spots", value: "spots", class: "py-3" },
      { text: "Autos", value: "cars", class: "py-3" },
      { text: "Cartel Colocado", value: "has_sticker", class: "py-3", sortable: false },
      { text: "Acciones", value: "actions", class: "py-3", sortable: false },
    ],
    roles: [],
    options: {
      itemsPerPage: 30,
      sortBy: ["_id"],
      sortDesc: [false],
      show_all: '',
    },
    iva_conditions: ['RESP. INSCRIPTO', 'MONOTRIBUTISTA', 'CONS. FINAL', 'RELACIÓN DE DEPENDENCIA', 'JUBILADO', 'OTRO']
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + "roles")
          .then((response) => {
            commit("success", { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
    unsubscribe({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'subscribe_email', data)
          .then((response) => {
            commit("success");
            resolve(response.data);
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
    sent_code_email({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(config.api_url + 'sent_code_email', data)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
    set_coins({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .put(config.api_url + 'set_coins' + '/' + data.id, data)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch((error) => {
            commit("error");
            reject(error.response.data);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
